// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"7768a601","513":"87034da1","703":"6ebe5a53"}[chunkId] + ".chunk.js";
};